import { MasterSocietyModel } from '@core/domain/model/master/master-society.model';
import { MasterInstallationModel } from '@core/domain/model/master/master-installation.model';
import { StringIdName } from '@core/domain/model/master/string-id-name.model';

export interface MasterState {
  societies: MasterSocietyModel[] | null;
  errorSocieties: string | null;
  installations: MasterInstallationModel[] | null;
  errorInstallations: string | null;
  roadTypes: StringIdName[] | null;
  errorRoadTypes: string | null;
  selfConsumptions: StringIdName[] | null;
  errorSelfConsumptions: string | null;
  cups: StringIdName[] | null;
  errorCups: string | null;
  subsectionType: StringIdName[] | null;
  errorSubsectionType: string | null;
  installationType: StringIdName[] | null;
  errorInstallationType: string | null;
}

export const masterInitialState: MasterState = {
  societies: null,
  errorSocieties: null,
  installations: null,
  errorInstallations: null,
  roadTypes: null,
  errorRoadTypes: null,
  selfConsumptions: null,
  errorSelfConsumptions: null,
  cups: null,
  errorCups: null,
  subsectionType: null,
  errorSubsectionType: null,
  installationType: null,
  errorInstallationType: null,
};
